import { useCallback } from 'react'
import {
	ApiGetWithToken,
	useApiFetch
} from 'shared/api'
import {
	clientApi,
	productApi
} from 'interface/endpoints'
import {
	ProductResultList,
	ProductCategoryResult,
	ProductCategoryResultList
} from './types'

export * from './types'

// 1日単位でのcacheTime
const t = Math.floor(new Date().getTime() / 86400000)

export const useListProduct = (
	manufacturerId: number | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!manufacturerId) return null
      return ApiGetWithToken<ProductResultList>(
        apiAccess,
				productApi(`/manufacturer/${manufacturerId}`, { t }),
        cancelToken
      )
    },
		[manufacturerId]
	)
)

export const useListProductCategory = (
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      return ApiGetWithToken<ProductCategoryResultList>(
        apiAccess,
				productApi('/category/list', { t }),
        cancelToken
      )
    },
		[]
	)
)

export const useGetProductCategory = (
	categoryCode: string | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!categoryCode) return null
      return ApiGetWithToken<ProductCategoryResult>(
        apiAccess,
				clientApi(`/category/${categoryCode}`, { t }),
        cancelToken
      )
    },
		[categoryCode]
	)
)
